/**
 * The number as the client would read it out; Telnyx answers in E.164. Anything that is not a ten-digit US
 * number comes back untouched, and a leading `+` is a claim about the whole number — so a short one is
 * malformed rather than local.
 */
export const formatSignupNumber = (phoneNumber: string): string => {
  const digits = phoneNumber.replace(/\D/g, '');
  const international = phoneNumber.trim().startsWith('+');

  const local = digits.length === 11 && digits.startsWith('1')
    ? digits.slice(1)
    : (international ? '' : digits);
  if (local.length !== 10) return phoneNumber;

  return `${local.slice(0, 3)}-${local.slice(3, 6)}-${local.slice(6)}`;
};
